/* eslint-disable sonarjs/different-types-comparison -- actually works as expected*/
/* eslint-disable prefer-rest-params -- gets ugly( */
/* eslint-disable @typescript-eslint/unbound-method -- `this` is bound to the Node prototype */
/*
  Why this is here? Built-in browser translations mess with the DOM nodes,
  which leads to React loosing track of them and being unable to render the tree and crashing to the nearest ErrorBoundary.

  This is almost official solution from React team adapted and formated: https://github.com/facebook/react/issues/11538#issuecomment-417504600
*/
const originalRemoveChild = Node.prototype.removeChild;

const newRemoveChild = function (this: Node, child: Node) {
  if (child.parentNode !== this) {
    console.error('Cannot remove a child from a different parent', child, this);

    return child;
  }

  return Reflect.apply(originalRemoveChild, this, arguments);
};

const originalInsertBefore = Node.prototype.insertBefore;

const newInsertBefore = function (this: Node, node: Node, referenceNode: Node | null) {
  if (referenceNode && referenceNode.parentNode !== this) {
    console.error('Cannot insert before a reference node from a different parent', referenceNode, this);

    return node;
  }

  return Reflect.apply(originalInsertBefore, this, arguments);
};

export const preventTranslationCrash = () => {
  if (typeof Node === 'function') {
    Node.prototype.removeChild = newRemoveChild;
    Node.prototype.insertBefore = newInsertBefore;
  }
};
